module.exports = __webpack_public_path__ + "img/premb-r-pm.e5378c89.svg";